<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/wareList">物流信息</BreadcrumbItem>
        <BreadcrumbItem>{{
          currentType == 1 ? "编辑" : "新增"
        }}</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/material" slot="extra">返回</router-link>
    <Form
      :style="{ width: '420px', margin: '0 auto' }"
      ref="formValidate"
      :model="formInline"
      :rules="ruleValidate"
      class="inputForm"
    >
      <Form-item label="物料名称" prop="name">
        <Input
          v-model="formInline.name"
          placeholder="请输入物料名称"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="物料别名" prop="nickName">
        <Input
          v-model="formInline.nickName"
          placeholder="请输入物料别名"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>

      <Form-item label="物料类型" prop="materialTypeCode">
        <Select
          style="width: 300px"
          v-model="formInline.materialTypeCode"
          placeholder="请选择物料类型"
        >
          <Option
            v-for="(item, index) in typeCodeList"
            :key="index"
            :value="item.materialTypeCode"
            >{{ item.name }}</Option
          >
        </Select>
      </Form-item>
      <Form-item label="物料简写" prop="shortName">
        <Input
          v-model="formInline.shortName"
          placeholder="请输入物料简写(纯字母)"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="品牌编号" prop="brandCode">
        <Select
          style="width: 300px"
          v-model="formInline.brandCode"
          placeholder="请选择品牌编号"
        >
          <Option
            v-for="(item, index) in brancCodeList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </Form-item>
      <Form-item label="渠道编码" prop="channelCode">
        <Select
          style="width: 300px"
          v-model="formInline.channelCode"
          placeholder="请选择渠道编码"
        >
          <Option
            v-for="(item, index) in channelList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </Form-item>

      <Form-item label="二维码基础编码" prop="qrBaseCode">
        <Input
          v-model="formInline.qrBaseCode"
          placeholder="示例：YDBMT-ALL-202112V001"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="批次号" prop="batchNumber">
        <Input
          :disabled="true"
          v-model="batchNumber"
          placeholder="请输入批次号"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="二维码尺寸" prop="qrSize">
        <Input
          v-model="formInline.qrSize"
          placeholder="例：10cm*15cm 默认4cm*4cm"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>

      <FormItem label="生效日期" prop="startDate">
        <DatePicker
          style="width: 70%"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择开始时间"
          :value="formInline.startDate"
          @on-change="(v) => timeChange(v, 'startDate')"
        ></DatePicker>
      </FormItem>
      <FormItem label="失效日期" prop="endDate">
        <DatePicker
          style="width: 70%"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择失效时间"
          :value="formInline.endDate"
          @on-change="(v) => timeChange(v, 'endDate')"
        ></DatePicker>
      </FormItem>
      <Form-item label="下发数量" prop="sendNum">
        <Input
          v-model="formInline.sendNum"
          placeholder="请输入下发数量"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="补发数量" prop="resendNum">
        <Input
          v-model="formInline.resendNum"
          placeholder="请输入补发数量"
          style="width: 300px"
          type="text"
        ></Input>
      </Form-item>
      <Form-item label="备注" prop="remark">
        <Input
          v-model="formInline.remark"
          placeholder="请输入备注"
          style="width: 300px"
          type="textarea"
        ></Input>
      </Form-item>
      <FormItem label="物料设计图" prop="designImage">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :action="uploadUrl"
          :before-upload="beforeUpload"
          :on-success="(value) => handleSuccess(value)"
          :on-error="(value) => onError(value)"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048000"
          :headers="{ token: $sessionToken() }"
        >
          <Button
            icon="ios-cloud-upload-outline"
            :loading="uploading"
            style="width: 290px"
            >上传图片</Button
          >
        </Upload>
        <div
          v-if="formInline.designImage"
          :style="{ marginTop: '5px', paddingLeft: '100px' }"
        >
          <Avatar shape="square" size="large" :src="formInline.designImage" />
        </div>
        <div>仅支持jpg/png,建议不超过5M</div>
      </FormItem>
      <Form-item label="物料状态" prop="status">
        <Select
          style="width: 300px"
          v-model="formInline.status"
          placeholder="物料状态"
        >
          <Option
            v-for="(item, index) in statusList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </Form-item>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >保存</Button
        >
        <Button @click="handleReset('formValidate')" style="margin-left: 8px"
          >重置</Button
        >
      </FormItem>
    </Form>
  </Card>
</template>

<script>
import axios from "axios";
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    const vaTime = (rule, value, callback) => {
      if (this.formInline.startDate && this.formInline.endDate) {
        if (this.formInline.startDate > this.formInline.endDate) {
          callback(new Error("生效时间不能大于失效时间"));
        } else {
          callback();
        }
      }
    };
    const valdBatNUmber = (rule, value, callback) => {
      if (this.batchNumber) {
        callback();
      } else {
        callback(new Error("批次号不能为空"));
      }
    };
    const valdTypeCode = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        callback(new Error("请选择物料类型"));
      }
    };
    return {
      channelList: [
        { name: "GT", code: "GT" },
        { name: "KA", code: "KA" },
        { name: "OTHERS", code: "OTHERS" },
      ],
      brancCodeList: [],
      typeCodeList: [],
      statusList: [
        {
          name: "有效",
          code: "0",
        },
        {
          name: "无效",
          code: "1",
        },
      ],
      currentType: 0,
      formInline: {
        addUserId: "1",
        batchNumber: "",
        brandCode: "",
        channelCode: "",
        // code: "",
        designImage: "",
        endDate: "",
        materialImg: "",
        materialTypeCode: "",
        name: "",
        nickName: "",
        qrBaseCode: "",
        qrSize: "",
        remark: "",
        resendNum: "",
        sendNum: "",
        shortName: "",
        startDate: "",
        status: "",
      },
      ruleValidate: {
        designImage: [
          { required: true, message: "物料设计图不能为空", trigger: "change" },
        ],
        batchNumber: [
          { required: true, validator: valdBatNUmber },
        ],
        status: [
          { required: true, message: "请选择物料状态", trigger: "change" },
        ],
        nickName: [
          { required: true, message: "请输入物料别名", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
        materialTypeCode: [
          {
            required: true,
            validator: valdTypeCode,
            trigger: "change",
          },
        ],
        shortName: [
          {
            required: true,
            message: "请输入物料简写(纯字母)",
            trigger: "blur",
          },
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "名字简称需为纯字母",
                /^[A-Za-z]+$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        brandCode: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        channelCode: [
          { required: true, message: "请选择渠道编码", trigger: "change" },
        ],
        qrBaseCode: [
          {
            required: true,
            message: "请输入二维码基础编码",
            trigger: "blur",
          },
        ],
        qrSize: [
          { required: true, message: "请输入二维码尺寸", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择生效日期", trigger: "change" },
          {
            trigger: "change",
            required: true,
            validator: vaTime,
          },
        ],
        endDate: [
          { required: true, message: "请选择失效日期", trigger: "change" },
          {
            trigger: "change",
            required: true,
            validator: vaTime,
          },
        ],
        resendNum: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^[1-9]\d*$/, value, callback),
            trigger: "blur",
          },
        ],
        sendNum: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^[1-9]\d*$/, value, callback),
            trigger: "blur",
          },
        ],
      },
      uploading: false,
      uploadUrl: "",
    };
  },
  computed: {
    batchNumber() {
      let data = this.formInline.qrBaseCode;
      if (data) {
        let list = data.split("-");
        return list[2];
      }
    },
  },
  created() {
    this.uploadUrl = axios.defaults.baseURL + "base/file/publicUpload";
    this.init();
  },
  methods: {
    init() {
      this.getBrandList();
      this.getData();
      this.getMaterialType();
      // this.getChannelList();
    },
    getMaterialType() {
      this.$api.materManType().then((res) => {
        if (res.code == 200) {
          this.typeCodeList = res.data;
        }
      });
    },
    getChannelList() {
      this.$api
        .channelInfoqQueryList({ page: 1, pageSize: 9999 })
        .then((res) => {
          if (res.code == 200) {
            this.channelList = res.data;
          }
        });
    },
    getData() {
      let q = this.$route.query;
      if (q.code) {
        this.currentType = 1;
        this.$api["materManDetail"](q).then((res) => {
          if (res.code == "200") {
            let d = res.data;
            d.materialTypeCode = d.materialTypeCode.toString();
            Object.keys(this.formInline).forEach((key) => {
              this.formInline[key] = d[key];
            });
          }
        });
      }
    },
    getBrandList() {
      this.$api.brandAll().then((res) => {
        if (res.code == 200) {
          this.brancCodeList = res.data;
          this.brancCodeList.unshift({
            code: "-1",
            name: "ALL",
          });
        }
      });
    },
    timeChange(v, type) {
      this.formInline[type] = v;
    },
    handleSubmit(name) {
      let data = { ...this.formInline };
      data.addUserId = window.sessionStorage.getItem("loginId");
      data.batchNumber = this.batchNumber;
      let path = "materManAdd";
      if (this.currentType == 1) {
        path = "materManUpt";
        data.code = this.$route.query.code;
        data.startDate = this.tools.formatDate(data.startDate, true);
        data.endDate = this.tools.formatDate(data.endDate, true);
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api[path](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.$router.replace({ path: "/material" });
            }
          });
        }
      });
    },
    handleReset(name) {
      for (let key in this.formInline) {
        this.formInline[key] = "";
      }
      this.$refs[name].resetFields();
    },
    beforeUpload(d) {
      let size = d.size;
      let type = d.type;
      if (size > 2048000) {
        this.$Message.error("图片不可大于2M");
        return false;
      }
      if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
        this.$Message.error("仅支持jpg/png");
        return false;
      }
      this.uploading = true;
    },
    handleSuccess(value) {
      this.uploading = false;
      let data = value.data;
      if (this.formInline.designImage == undefined) {
        this.formInline.designImage = "";
      } else {
        this.formInline.designImage = data.url;
      }
    },
    onError(value) {
      this.formInline.designImage = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
  },
};
</script>

<style scoped>
.inputForm /deep/.ivu-form .ivu-form-item-label {
  min-width: 110px;
}
</style>


// WEBPACK FOOTER //
// src/views/material/add.vue